import moment from "moment";

function formatCurrentDateTime(formatTo = 'YYYY-MM-DD HH:mm:ss') {
	return moment().format(formatTo)
}

function formatDateTimeAsUnix(dateTime, defaultFormat = 'YYYY-MM-DD HH:mm:ss') {
	return moment(dateTime, defaultFormat).unix()
}

function subtractFromDateTime(dateTime, value = 1970, unit = 'year', defaultFormat = 'YYYY-MM-DD HH:mm:ss') {
	return moment(dateTime, defaultFormat).subtract(value, unit)
}

function addFromDateTime(dateTime, value = 1970, unit = 'year', defaultFormat = 'YYYY-MM-DD HH:mm:ss') {
	return moment(dateTime, defaultFormat).add(value, unit)
}

export const moments = {
	addFromDateTime,
	subtractFromDateTime,
	formatDateTimeAsUnix,
	formatCurrentDateTime
};
